import { Record } from 'immutable';

const DebtorOutstandingRecord = Record({
  id: 0,
  year: 0,
  month: 0,
  outstandingAmount: 0,
});

export default class DebtorOutstanding extends DebtorOutstandingRecord {
  static deserialize(jsonObject = {}) {
    return new DebtorOutstanding(jsonObject);
  }
}
